import script from "./MallOrdersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallOrdersPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallOrdersPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__